import Head from "@wigets/head.vue";
import Foot from "@wigets/foot.vue";
import { e_enterpriseList, getpic,bayWindow,getPVUV } from "@apis/apis.js";
import Swiper from "swiper";
export default {
  components: {
    "web-head": Head,
    "web-foot": Foot,
  },
  data() {
    return {
      tab: 7,
      link:'',
      mess:"http://dzswgf.mofcom.gov.cn/news_attachments/87b48fb6457b7b4547d8459e3d4573c442f8f229.pdf",
      // 诚信承诺企业请求参数
      queryInfo: {
        page: 1,
        limit: 20,
      },
      // 企业列表
      enterpriseList: [],
      // 企业总数量
      totalCount: 0,
      // 当limit为7时，第二页第一条数据
      singleEnterprise: null,
      // 企业登录参数
      loginOrRegister: {
        name: "",
        password: "",
        code: "",
      },
      // 验证码图片
      codeImg: "",
      // 诚信承诺书地址列表
      honestyCommit: [],
    };
  },
  created() {
    this.getCode();
    this.getEnterpriseList();
    this.Bywindow()
    this.getpvuv()
    // this.getOneEnterprise();
  },
  mounted() {
    this.$nextTick(() => {
      this.initCarousel();
    });
  },
  methods: {
    //埋点
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "信用共建",
        directoryTwo: null,
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    // 头部head状态保持
    changeTab(val) {
      this.tab = val;
    },
    // 面包屑导航跳转
    navPosition(name) {
      this.$router.push({ name });
    },
    /**
     *  飘窗接口
     * @param {*}
     * @param {*}
     */
    Bywindow(){
      this.$ajaxGet(`${bayWindow}?type=0`).then(res =>{
        if(res.data.code == 0){
          if(res.data.data){
            this.link = res.data.data.link
          }
        }else{
          this.$message({
            title: "错误",
            type: "error",
            message: res.data.msg + ",请重新刷新",
          });
        }
      })
    },
    // 初始化轮播图
    initCarousel() {
      this.$nextTick(() => {
        const mySwiper = new Swiper(".commit-swiper", {
          slidesPerView: 4,
          spaceBetween: 25,
          autoplay: true,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          observer: true,
          observeParents: true,
        });
        mySwiper.el.onmouseover = function() {
          //鼠标放上暂停轮播
          mySwiper.autoplay.stop();
        };
        mySwiper.el.onmouseleave = function() {
          mySwiper.autoplay.start();
        };
      });
    },
    // 请求企业列表
    getEnterpriseList() {
      this.$ajaxPost(e_enterpriseList, this.queryInfo, {
        honestyType: "1",
      }).then(({ data }) => {
        this.enterpriseList = data.data.list
        this.totalCount = data.data.totalCount;
        this.getHonestyCommit(data.data.list)
      });
    },
    getHonestyCommit(data) {
      if (!data.length) return
      data.forEach(res => {
        this.honestyCommit.push(res.commitment)
      });
    },
    // 获取第二页第一条数据
    /*  getOneEnterprise() {
      this.$ajaxPost(
        e_enterpriseList,
        { page: 2, limit: 7 },
        {
          honestyType: "1",
        }
      ).then(({ data }) => {
        if (data.data.list && data.data.list.length > 0) {
          this.singleEnterprise = data.data.list[0];
        }
      });
    }, */
    // 点击更多企业数据
    getMoreEnterpriseList() {
      if (this.singleEnterprise) {
        this.enterpriseList.push(this.singleEnterprise);
        this.singleEnterprise = null;
      }
      this.$ajaxPost(
        e_enterpriseList,
        { limit: 8, page: this.queryInfo.page },
        {
          honestyType: "1",
        }
      ).then(({ data }) => {
        this.enterpriseList.push(...data.data.list);
      });
    },
    // 跳转到诚信企业
    navToenterpriseNew(e) {
      let el = null;
      for(let i = 0; i < e.path.length; i++) {
        if(e.path[i].className === 'e-item') {
          el = e.path[i]
        }
      }
      this.$router.push({ name: "detailPage", query: { id: el.dataset.id } });
    },
    // 点击获取更多企业
    getMore() {
      if (this.enterpriseList.length >= this.totalCount) return;
      this.queryInfo.page++;
      this.getMoreEnterpriseList();
    },
    // 跳转到诚信承诺企业页面
    skipRouter(name, type) {
      this.$router.push({ name, params: { type } });
    },
    // 获取验证码
    getCode() {
      this.$ajaxGet(getpic)
        .then(({ data }) => {
          this.codeImg = data.data.ClientImage;
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
          });
        });
    },
  },
  computed:{
    optionRight () {
      return {
        direction: 3,
      }
    }
  }
};